import React from 'react';
import ApexCharts from 'react-apexcharts';
import { useTheme } from '@material-ui/styles';

const example = {
  series: [
    {
      name: 'Net Profit',
      data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
    },
    {
      name: 'Revenue',
      data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
    },
    {
      name: 'Free Cash Flow',
      data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
    },
  ],
  categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
};

// ############################################################
function themeOptions(theme, categories) {
  return {
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      // type: 'datetime',
      categories,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: '55%',
        endingShape: 'rounded',
      },
    },
    tooltip: {
      // Follows the app's light/dark mode; Apex defaults to a light tooltip.
      theme: theme.palette.type,
      x: {
        format: 'dd/MM/yy HH:mm',
      },
    },
    fill: {
      colors: [theme.palette.primary.light, theme.palette.success.light],
    },
    colors: [theme.palette.primary.main, theme.palette.success.main],
    chart: {
      type: 'bar',
      height: 350,
      toolbar: {
        show: false,
      },
    },
    legend: {
      show: false,
    },
  };
}

function ApexLineChart({ data }) {
  const theme = useTheme();

  return (
    <ApexCharts options={themeOptions(theme, data?.categories)} series={data?.series || []} type="bar" height={350} />
  );
}

export default ApexLineChart;
